import { is } from "ramda";
import { Timeline } from "antd";
import { withTheme } from "styled-components";
import moment from "moment";
import React from "react";

import { Container, Title } from "./style";
import ColorUtil from "../../../util/ColorUtil";

const IndividualUserTimeline = ({ timeline, theme, visualColorKey }) => {
	const timelineArr = is(Object, timeline) ? Object.keys(timeline).map(key => timeline[key]) : timeline;
	const color = ColorUtil.getVisualizeColor(theme, visualColorKey, 0, 1);
	return (
		<Container>
			<Title style={{ marginBottom: 15 }}>Timeline</Title>
			{
				timelineArr && timelineArr.length > 0 ?
					<Timeline>
						{
							timelineArr.sort((a, b) => b.date - a.date).map((value, index) => {
								return <TimelineItem
									key={index}
									color={color}
									date={moment.unix(value.date).format("DD-MM-YYYY HH:mm")} //moment.unix(value).format("MM/DD/YYYY")
									description={value.description} />;
							})
						}
					</Timeline>
					: <div style={{ textAlign: "center" }}>No data</div>
			}
		</Container>
	);
};

const TimelineItem = ({ date = "", description = "", color }) => (
	<Timeline.Item color={color}>
		<p style={{ color: "rgba(0, 0, 0, 0.35)" }}>{date}</p>
		<p>{description}</p>
	</Timeline.Item>
);

export default withTheme(IndividualUserTimeline);


// WEBPACK FOOTER //
// ./src/components/report/individual_user/IndividualUserTimeline.js